import type { ReactNode } from "react";

type SectionHeadingProps = {
  eyebrow?: string;
  title: ReactNode;
  description?: string;
  align?: "left" | "center";
  id?: string;
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  id,
}: SectionHeadingProps) {
  const alignment = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignment} gap-3 mb-8 md:mb-12`} id={id}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label tracking-[0.2em] text-primary-600 dark:text-primary-400 uppercase">
          <span className="inline-block w-6 h-px bg-primary-500" />
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
        {title}
      </h2>
      {description && (
        <p className={`font-body text-sm md:text-base text-foreground-600 leading-relaxed ${align === "center" ? "max-w-2xl" : "max-w-3xl"}`}>
          {description}
        </p>
      )}
    </div>
  );
}